import {observer} from 'mobx-react';
import {useDrag} from 'react-dnd';
import {FormattedMessage} from 'react-intl';
import {Tooltip} from 'shared/components';
import ActionLink from 'shared/components/links/ActionLink';
import {t} from 'shared/core';

export const SHIFT_DRAG_TYPE = 'SHIFT';

const ShiftCard = observer(({uiState, shift}) => {
  const [{isDragging}, connectDrag] = useDrag({
    type: SHIFT_DRAG_TYPE,
    item: () => ({shiftId: shift.id}),
    end: (item, monitor) => uiState.endShiftDrag(item.shiftId, monitor.didDrop()),
    collect: monitor => ({isDragging: monitor.isDragging()})
  });

  return (
    <div
      ref={connectDrag}
      className={`ShiftCard ${shift.employeeId ? '' : 'ShiftCard--unassigned'} ${shift.published ? 'ShiftCard--published' : 'ShiftCard--draft'} ${uiState.isOverlapping(shift) ? 'ShiftCard--overlapping' : ''} ${isDragging ? 'ShiftCard--dragging' : ''}`}
      onClick={() => uiState.openEditShiftModal(shift)}
    >
      <div className='medium'>{shift.timeRange}</div>
      {Number(shift.unpaidBreakMinutes) > 0 && <div className='ShiftCard-details truncate'>
        <FormattedMessage id='time_tracking.shifts.BREAK_MINUTES' values={{minutes: shift.unpaidBreakMinutes}}/>
      </div>}
      {shift.dimensionValues.map(dimensionValue => (
        <div key={dimensionValue.id} className='ShiftCard-details truncate'>{dimensionValue.name}</div>
      ))}
      {(shift.note || shift.scheduleRule) && <div className='ShiftCard-icons'>
        {shift.scheduleRule && <Tooltip content={shift.scheduleRule.summary}>
          <i className='material-symbols-solid ShiftCard-icon'>{'repeat'}</i>
        </Tooltip>}
        {shift.note && <Tooltip content={shift.note} contentClassName='ShiftCard-note'>
          <i className='material-symbols-solid ShiftCard-icon'>{'sticky_note_2'}</i>
        </Tooltip>}
      </div>}
      <ActionLink
        className='ShiftCard-delete'
        aria-label={t('time_tracking.shifts.Delete Shift')}
        onClick={e => {
          e.stopPropagation();
          uiState.requestDeleteShift(shift);
        }}
      >
        <i className='material-symbols-solid'>{'close'}</i>
      </ActionLink>
    </div>
  );
});

export default ShiftCard;
